import { AdminLayout } from '@/components/layouts'
import { PageContentForm } from './PageContentForm'

interface Community {
  id: number
  name: string
}

interface ContentType {
  value: string
  label: string
}

interface NewProps {
  communities: Community[]
  content_types: ContentType[]
}

export default function New({ communities, content_types }: NewProps) {
  return (
    <AdminLayout
      title="Nouveau contenu éditable"
      breadcrumbs={[
        { label: 'Contenus éditables', href: '/admin/page_contents' },
        { label: 'Nouveau' }
      ]}
    >
      <PageContentForm
        communities={communities}
        contentTypes={content_types}
      />
    </AdminLayout>
  )
}
